export default __webpack_public_path__ + "static/media/audioOn.5dae254d.svg";